import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from 'react';
import { Button, Container, Row, Col, Form } from "react-bootstrap";
export default (function (props) {
  var customerList = props.customerList,
      _props$getCusomerList = props.getCusomerList,
      getCusomerList = _props$getCusomerList === void 0 ? function () {
    return console.log('get list');
  } : _props$getCusomerList,
      _props$assignCust = props.assignCust,
      assignCust = _props$assignCust === void 0 ? function () {
    return console.log('assign Customer');
  } : _props$assignCust,
      _props$resetCustomerL = props.resetCustomerList,
      resetCustomerList = _props$resetCustomerL === void 0 ? function () {
    return console.log('reset customerlist');
  } : _props$resetCustomerL,
      _props$setLoaderAfter = props.setLoaderAfterAssign,
      setLoaderAfterAssign = _props$setLoaderAfter === void 0 ? function () {
    return console.log('loader after modal close');
  } : _props$setLoaderAfter;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      userSearchText = _useState2[0],
      setUserSearchText = _useState2[1];

  var _useState3 = useState("cb-button-primary cust-search-btn"),
      _useState4 = _slicedToArray(_useState3, 2),
      searchBtnClass = _useState4[0],
      setSeacrhBtncls = _useState4[1];

  useEffect(function () {
    setUserSearchText('');
    resetCustomerList();
  }, []);

  var userSearchTextUpdate = function userSearchTextUpdate(e) {
    setUserSearchText(e.target.value);
    setSeacrhBtncls(validateEmail(e.target.value) ? "cb-button-primary cust-search-btn" : "cb-button-primary cust-search-btn filter-disabled");
  };

  var searchUser = function searchUser() {
    getCusomerList(userSearchText);
  };

  var validateEmail = function validateEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  };

  var assign = function assign(customer) {
    setLoaderAfterAssign();
    assignCust(customer);
  };

  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Form.Control, {
    autoFocus: true,
    className: "offline_search",
    type: "text",
    value: userSearchText,
    onChange: userSearchTextUpdate,
    placeholder: "Seacrh with customer email id"
  }), /*#__PURE__*/React.createElement(Button, {
    className: searchBtnClass,
    onClick: searchUser
  }, "Search"))), customerList && customerList.length > 0 && customerList.map(function (cust) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("label", null, "First Name")), /*#__PURE__*/React.createElement(Col, null, cust.FirstName)), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("label", null, "Last Name")), /*#__PURE__*/React.createElement(Col, null, cust.LastName)), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("label", null, "Email Id")), /*#__PURE__*/React.createElement(Col, null, cust.EmailAddress)), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("label", null, "Phone Number")), /*#__PURE__*/React.createElement(Col, null, cust.PrimaryPhone || "NA")), /*#__PURE__*/React.createElement(Button, {
      className: "cb-button-primary cust-search-btn",
      onClick: function onClick() {
        return assign(cust);
      }
    }, "Assign"));
  }));
});